import Axios, { AxiosError } from 'axios';

import { getToken } from '@/routes/(auth)/lib/token';
import { Navigate, redirect } from '@tanstack/react-router';

export const AXIOS_INSTANCE = Axios.create({
  baseURL: import.meta.env.VITE_BACKEND_URL,
});

type CustomClient<T> = (data: {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  params?: Record<string, string>;
  headers?: Record<string, unknown>;
  data?: BodyType<unknown>;
  signal?: AbortSignal;
}) => Promise<T>;

export const useCustomClient =
  <T>(): CustomClient<T> =>
  async ({ method, params, data, url }) => {
    const token = getToken();

    const response = await AXIOS_INSTANCE.request<T>({
      method,
      url,
      params,
      data,
      headers: {
        ...data?.headers,
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

export default useCustomClient;

export type ErrorType<ErrorData> = ErrorData;

export type BodyType<BodyData> = BodyData & {
  headers?: Record<string, string>;
};
